module.exports = __webpack_public_path__ + "scroll-bar.abfbc517.png";